
/**
 * 주문 상태
 */
export type GetOrders200OrdersItemStatus = typeof GetOrders200OrdersItemStatus[keyof typeof GetOrders200OrdersItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrders200OrdersItemStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
} as const;
